export default {
    init() {
        this.initResyncButton();
        this.initCustomerSyncButton();
        this.initTicketButton();
    },

    initResyncButton() {
        let $this = this;

        $('body').on('click', '.resync-qb-button', function() {
            $('#qb_resync_load_display').css('display', 'block');

            let syncButton = $(this);
            let objectId = syncButton.data('qb_object_id');
            let objectType = syncButton.data('qb_object_type');
            let url = "/quickbooks-integration/resync";
            let messageContainer = objectType === "Payment"
                ? $(this).parents('.result-message-container')
                : $('.result-message-container');

            $.ajax({
                url: url,
                method: 'POST',
                data: {
                    sync_object_id: objectId,
                },
                success: (response) => {
                    $this.clearMessageContainer(messageContainer);

                    if (response.status) {
                        $this.setSuccess(messageContainer, syncButton ,objectType);
                    } else{
                        $this.setFailded(messageContainer, syncButton, response.user_sync_count, response.error || response.message);
                    }
                },
                error: (response) => {
                    if (response.responseJSON?.token_fail) {
                        window.location.href = "/settings/integrations-list";
                        return;
                    }

                    $this.clearMessageContainer(messageContainer);
                    $this.setFailded(
                        messageContainer,
                        syncButton,
                        response.responseJSON?.user_sync_count || 0,
                        response.responseJSON?.message || 'QuickBooks fix failed with an error.'
                    );
                },
                complete: () => {
                    $('#qb_resync_load_display').css('display', 'none');
                },
            });
        });
    },

    initCustomerSyncButton() {
        let $this = this;

        $('body').on('click', '.sync-customer-button', function() {
            $('#qb_resync_load_display').css('display', 'block');

            let syncButton = $(this);
            let infoBlockErrors = $('.info-block-errors');
            let url = '/customers/quickbooks/sync';
            let data = {};

            let syncData = syncButton.data('sync_data');

            if (syncData['quickbooks_id']) {
                data.to_bizbaby = [JSON.stringify(syncButton.data('sync_data'))];
            } else {
                data.to_quickbooks = [JSON.stringify(syncButton.data('sync_data'))];
            }

            $.ajax({
                url: url,
                method: 'POST',
                data: data,
                success: () => {
                    $this.clearMessageContainer(messageContainer, syncButton);
                    $this.setSuccess(messageContainer, syncButton, "Customer");
                },
                error: (response) => {
                    $this.clearMessageContainer(messageContainer, syncButton);
                    $this.setFailded(
                        messageContainer,
                        syncButton,
                        response.responseJSON.user_sync_count,
                        response.responseJSON.message
                    );
                },
                complete: () => {
                    infoBlockErrors.css('display', 'block');
                    $('#qb_resync_load_display').css('display', 'none');
                }
            });
        });

    },

    initTicketButton() {
        let $this = this;

        $('body').on('click', '#quickbooks_submit_ticket_button', function() {
            const type = $('#quickbooks_submit_ticket_button').data('qb_object_type');
            const syncObjectId = $('#quickbooks_submit_ticket_button').data('qb_object_id');

            if (syncObjectId) {
                // Автоматически делаем ресинк перед отправкой тикета
                $.ajax({
                    url: '/quickbooks-integration/resync',
                    type: 'POST',
                    data: {
                        sync_object_id: syncObjectId,
                        force: true // Принудительная синхронизация при отправке тикета
                    },
                    success: () => {
                        // После ресинка получаем данные о sync object для тикета
                        $.ajax({
                            url: '/quickbooks-integration/sync-object-for-ticket',
                            method: 'GET',
                            data: {
                                sync_object_id: syncObjectId
                            },
                            success: (response) => {
                                if (response.status) {
                                    // Импортируем HelpTicket динамически
                                    import('../CRUDs/entities/HelpTicket.js').then((module) => {
                                        const HelpTicket = module.default;
                                        const helpTicket = new HelpTicket();

                                        // Формируем subject и details
                                        const subject = 'Errors With QuickBooks';
                                        let details = `${response.type} ID: ${response.org_local_id || 'N/A'}`;

                                        if (response.error_details) {
                                            details += `\n\nError details:\n${response.error_details}`;
                                        }

                                        // Открываем модалку и предустанавливаем значения
                                        helpTicket.openModal('create');

                                        // Ждем, пока форма загрузится, затем заполняем
                                        // Используем событие load_modal для более надежной загрузки
                                        const fillForm = () => {
                                            if ($('#create-help_ticket-modal').length && $('#subjectTicket').length) {
                                                helpTicket.autocompleteForm(subject, details);
                                            } else {
                                                setTimeout(fillForm, 100);
                                            }
                                        };

                                        setTimeout(fillForm, 300);
                                    });
                                } else {
                                    // Если не удалось получить данные, просто открываем форму
                                    $('#open_help_ticket_form').trigger('click');
                                }
                            },
                            error: () => {
                                // В случае ошибки просто открываем форму
                                $('#open_help_ticket_form').trigger('click');
                            }
                        });
                    },
                    error: () => {
                        // Если ресинк не удался, все равно открываем форму тикета
                        $.ajax({
                            url: '/quickbooks-integration/sync-object-for-ticket',
                            method: 'GET',
                            data: {
                                sync_object_id: syncObjectId
                            },
                            success: (response) => {
                                if (response.status) {
                                    import('../CRUDs/entities/HelpTicket.js').then((module) => {
                                        const HelpTicket = module.default;
                                        const helpTicket = new HelpTicket();
                                        const subject = 'Errors With QuickBooks';
                                        let details = `${response.type} ID: ${response.org_local_id || 'N/A'}`;
                                        if (response.error_details) {
                                            details += `\n\nError details:\n${response.error_details}`;
                                        }
                                        helpTicket.openModal('create');
                                        const fillForm = () => {
                                            if ($('#create-help_ticket-modal').length && $('#subjectTicket').length) {
                                                helpTicket.autocompleteForm(subject, details);
                                            } else {
                                                setTimeout(fillForm, 100);
                                            }
                                        };
                                        setTimeout(fillForm, 300);
                                    });
                                } else {
                                    $('#open_help_ticket_form').trigger('click');
                                }
                            },
                            error: () => {
                                $('#open_help_ticket_form').trigger('click');
                            }
                        });
                    }
                });
            } else {
                // Если нет sync_object_id, просто открываем форму
                $('#open_help_ticket_form').trigger('click');
            }
        });
    },

    clearMessageContainer(messageContainer) {
        messageContainer
            .html('')
            .addClass('d-block')
            .css('height', 'auto')
            .append($('<div>').addClass('message').css('align-items', 'flex-start'));
    },

    setSuccess(messageContainer, syncButton, objectType) {
        messageContainer
            .find('.message')
            .addClass('success')
            .append($('<div>').append($('<img>').attr('src', 'images/individual-jobs/completed-icon.png')))
            .append($('<div>').append($('<p>')
                .html(objectType + ' fixed in QuickBooks sync')
                .css('padding-top', '5px')));

        syncButton.addClass('d-none');
    },

    setFailded(messageContainer, syncButton, userSyncCount, errorMessage) {
        if (userSyncCount >= 2) {
            syncButton.addClass('d-none');
        } else {
            syncButton.removeClass('disabled').prop('disabled', false);
        }

        messageContainer
            .find('.message')
            .addClass('error')
            .append($('<div>').append($('<img>').attr('src', 'images/individual-jobs/error-checkmark.png')))
            .append($('<div>').html(errorMessage));
    },
}
